import { ArrowDropDown, CheckBox, CheckBoxOutlineBlankOutlined } from '@mui/icons-material'
import { Autocomplete, Checkbox, Chip, FormControl, FormHelperText, InputLabel, MenuItem, Select, TextField, Tooltip } from '@mui/material'
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'
import { Controller } from 'react-hook-form'
import { isEmptyObj } from '../../utils/Utils'
import './CustomFormField.css'

export const CustomFormField = ({
    control = {},
    errorMessage = '',
    rules = {},
    readOnly = false,
    editMode = true,
    name,
    type = FieldTypes.text,
    onDropdownChange = () => { },
    onDropdownValueClear = () => { },
    options = [],
    customSxObj = {},
    showTooltip = false,
    label = '',
    disabled = false,
    placeholder = '',
    style = {},
    disableFuture = false,
    disablePast = false,
    textFieldType = FieldTypes.text,
    minDate = null,
    maxDate = null,
    fontSize = 11,
}) => {
    const renderField = (field) => {
        const getDropDownOptions = (selectedValue) => {
            const dropDownOptions = options?.length
                ? options
                : Boolean(selectedValue)//need to implement array of object logic 
                    ? [selectedValue]
                    : []
            return dropDownOptions || []
        }
        const sxObj = readOnly
            ? {
                border: 'none',
                "& fieldset": { border: 'none' },
            }
            : {
                border: !editMode && 'none',
                "& fieldset": { border: !editMode && 'none' },
            }
        const renderIcon = (field) => {
            // if (Boolean(field?.value)) {
            //     return <IconButton
            //         onClick={(e) => {
            //             field?.onChange(e);
            //             onDropdownChange('');
            //             onDropdownValueClear()
            //         }}>
            //         <Cancel />
            //     </IconButton>
            // }
            return <ArrowDropDown />;
        };

        switch (type) {
            case FieldTypes.text:
                return <TextField
                    {...field}
                    type={textFieldType}
                    fullWidth
                    placeholder={placeholder}
                    InputProps={{
                        readOnly: readOnly,
                        style: { height: 35, backgroundColor: editMode && 'white' }
                    }}
                    disabled={disabled}
                    error={Boolean(errorMessage)}
                    variant="outlined"
                    sx={{ ...sxObj, ...customSxObj }}
                />
            case FieldTypes.select:
                return <>
                    <Select
                        {...field}
                        onOpen={() => { }}
                        onChange={(e) => {
                            field?.onChange(e);
                            onDropdownChange(e.target.value);
                        }}
                        defaultValue={field?.value || ''}
                        labelId="demo-simple-select-label"
                        id="source"
                        style={{ height: 35, width: '100%', backgroundColor: 'white' }}
                        sx={{
                            ...sxObj,
                            border: !editMode && 'none',
                            "& fieldset": { border: !editMode && 'none' },
                            '.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled': {
                                // '-webkit-text-fill-color': readOnly && 'black',
                            },
                        }}
                        disabled={disabled}
                        inputProps={{ IconComponent: () => editMode ? renderIcon(field) : null }}
                    >
                        {getDropDownOptions(field?.value)?.map(ele => {
                            const isObj = typeof ele === 'object'
                            return <MenuItem key={Math.random() + ele} value={isObj ? ele?.value : ele}>{isObj ? ele?.label : ele}</MenuItem>
                        })}
                    </Select>
                </>
            case FieldTypes.date:
                return <>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                            {...field}
                            inputFormat="MM/dd/yyyy"
                            disableFuture={disableFuture}
                            disablePast={disablePast}
                            disabled={disabled || !editMode}
                            slotProps={{
                                textField: {
                                    variant: 'outlined',
                                    error: Boolean(errorMessage),
                                    style: { backgroundColor: 'white', ...style },
                                },
                            }}
                            minDate={dayjs(minDate)}
                            maxDate={dayjs(maxDate)}
                            sx={{
                                ...sxObj,
                                border: !editMode && 'none',
                                width: '100%',
                                "& fieldset": { border: !editMode && 'none' },
                                '.css-i4bv87-MuiSvgIcon-root': { display: !editMode && 'none' },
                                '.MuiInputBase-input': { fontSize }
                            }}
                        />
                    </LocalizationProvider>
                </>
            case FieldTypes.multiSelect:
                return <>
                    <Autocomplete
                        multiple
                        id="checkboxes-tags-demo"
                        limitTags={1}
                        options={options}
                        disableCloseOnSelect
                        onChange={(event, newValue) => {
                            field?.onChange(newValue); // Update field value
                        }}
                        value={field?.value}
                        getOptionLabel={(option) => option}
                        renderOption={(props, option, { selected }) => (
                            <li {...props} key={option}>
                                <Checkbox
                                    icon={<CheckBoxOutlineBlankOutlined fontSize="small" />}
                                    checkedIcon={<CheckBox fontSize="small" />}
                                    style={{ marginRight: 3 }}
                                    checked={selected}
                                />
                                {option}
                            </li>
                        )}
                        renderTags={(tagValue, getTagProps) => {
                            return tagValue.map((option, index) => (
                                <Chip color="primary" {...getTagProps({ index })} key={option} label={option} />
                            ))
                        }}
                        sx={{
                            "& .MuiInputBase-root": { backgroundColor: 'white' },
                            ".MuiAutocomplete-tag": { height: 'auto' },
                            ".MuiOutlinedInput-root": { padding: 0 }
                        }}
                        renderInput={(params) => (
                            <TextField {...params} placeholder={placeholder} />
                        )}
                    />
                </>
            default:
                break;
        }
    }
    return (
        <div>
            {Boolean(label) &&
                <InputLabel error={Boolean(errorMessage)} shrink htmlFor={name} style={{ fontSize: 20, fontWeight: 'bold' }}>
                    {label}
                </InputLabel>}
            {isEmptyObj(control)
                //only handled for select as of now
                ? <FormControl fullWidth error={Boolean(errorMessage)}>
                    {renderField()}
                    <FormHelperText>{errorMessage}</FormHelperText>
                </FormControl>
                : <Controller
                    name={name}
                    control={control}
                    rules={{ ...rules, disabled: readOnly }}
                    render={({ field }) =>
                        <Tooltip title={showTooltip ? field?.value : ''}>
                            <FormControl fullWidth error={Boolean(errorMessage)}>
                                {renderField(field)}
                                <FormHelperText>{errorMessage}</FormHelperText>
                            </FormControl>
                        </Tooltip>
                    }
                />}
        </div>
    )
}

export const FieldTypes = {
    text: "text",
    select: "select",
    date: "date",
    multiSelect: "multi-select",
}